import { LocationVarInheritance } from "@swivl-mono/types";

import { CortexInheritancePill } from "../../CortexV3/Components/CortexInheritancePill";
import { RowInheritanceControls } from "../../CortexV3/Components/RowInheritanceControls";
import { REVERT_TO_DEFAULT } from "../../CortexV3/Components/revertTarget";

interface RevertToDefaultProps {
  isCustomized: boolean;
  disabled: boolean;
  onRevert: () => void;
}

/** The Customized pill and Revert to Default button, as on the settings rows. */
export function RevertToDefault({ isCustomized, disabled, onRevert }: RevertToDefaultProps): React.ReactElement {
  if (disabled) return <CortexInheritancePill inheritance={isCustomized ? LocationVarInheritance.NONE : LocationVarInheritance.DEFAULT} />;
  return (
    <div className="flex shrink-0 items-center gap-3">
      <RowInheritanceControls
        inheritance={LocationVarInheritance.DEFAULT}
        overrideStaged={isCustomized}
        showCustomize={false}
        revertLabel={REVERT_TO_DEFAULT}
        onCustomize={() => undefined}
        onRevert={onRevert}
        onDiscard={onRevert}
      />
    </div>
  );
}
